import * as ko from 'knockout';

export interface IApplicationConfig {
	language: KnockoutObservable<string>;
	isRightToLeftLanguage: KnockoutObservable<boolean>;
	rtlCss: KnockoutComputed<'rtl' | 'ltr'>;
	defaultLanguage: string;
}

/**
 * @deprecated use "@mae/localization"
 */
export const ApplicationConfig: IApplicationConfig = {
	language: ko.observable('en'),
	isRightToLeftLanguage: ko.observable(false),
	rtlCss: ko.pureComputed(() => {
		return ApplicationConfig &&
			ko.isObservable(ApplicationConfig.isRightToLeftLanguage) &&
			ApplicationConfig.isRightToLeftLanguage()
			? 'rtl'
			: 'ltr';
	}),
	defaultLanguage: 'en'
};
